import React from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { CareerSection } from './components/CareerSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { PagePreviewSection } from './components/PagePreviewSection';
import { BonusesSection } from './components/BonusesSection';
import { BenefitsSection } from './components/BenefitsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { PricingSection } from './components/PricingSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-[#101914] text-stone-100" data-id="element-0" data-mp="23ujjma5idj2g">
      <UrgencyBanner data-id="element-1" data-mp="3ik7k0rkruvvx" />
      <Navbar data-id="element-2" data-mp="3iiweam7rne26" />
      <main data-id="element-3" data-mp="3ij61k21ff746">
        <HeroSection data-id="element-4" data-mp="3ijpd910hgz9r" />
        <ProblemSection data-id="element-5" data-mp="3ii4q3wgi0ilx" />
        <SolutionSection data-id="element-6" data-mp="3ml12v6jcxkhy" />
        <HowItWorksSection data-id="element-7" data-mp="3mk868ye44bdj" />
        <PagePreviewSection data-id="element-8" data-mp="3mjga9mglsbmq" />
        <CareerSection data-id="element-9" data-mp="3rcj7q5oi4587" />
        <BonusesSection data-id="element-10" data-mp="3rdaqgfx028h2" />
        <BenefitsSection data-id="element-11" data-mp="3rcsxbs5mwadd" />
        <GuaranteeSection data-id="element-12" data-mp="3relv0hy9rk98" />
        <PricingSection data-id="element-13" data-mp="6hp9c27i9cj" />
        <FAQSection data-id="element-14" data-mp="4n4pyuukj8z" />
        <ClosingSection data-id="element-15" data-mp="56lvdcob3ly" />
      </main>
      <Footer data-id="element-16" data-mp="2zld0746gb58w" />
    </div>;
}